angular
  .module("pe4h")
  .controller("Project", function(
    $scope,
    $rootScope,
    $http,
    $state,
    $interval,
    $uibModal,
    configuration,
    LoginService,
    $location,
    $timeout
  ) {
    var clipboardShare = null;
    $scope.hidePass = null;
    $scope.justHired = false;

    $scope.setReviewed = function(b) {
      if (b) $scope.justHired = true;
    };

    $scope.popup = false;

    $scope.setHidePass = function(v) {
      $scope.hidePass = v;
    };

    $scope.setHiredName = function(name) {
      $scope.hired = name;
    };
    // Map previous state to breadcrumb label/href
    var breadcrumbsDict = {
      requests: { label: "Requests", state: "requests" },
      proposals: { label: "Proposals", state: "proposals" },
      projects: { label: "Projects", state: "projects" }
    };

    $scope.project = null;
    if($rootScope.previousState){
      $scope.previousPage = breadcrumbsDict[$rootScope.previousState.name];
    }
    $scope.$state = $state;
    $scope.client = null;

    $scope.formatDate = function(dateString) {
      return moment(dateString).format("MM/DD/YYYY");
    }

    function initProject() {

      $http({
        url: configuration.webApi.projects.projects_uid({
          uid: $state.params.uid
        }),
        method: "GET"
      })
        .success(function(res, status, headers, config) {
          $scope.project = res;

          getProjectQuestions(res.Id);

          $scope.project.license = $scope.licensesDict[$scope.project.LicenseId];
          $scope.project.posted = $scope.formatDate($scope.project.CreatedDate);
          $scope.project._proposalChecked = false;

          var seoTitle = "contract " + $scope.project.license.Label + " job in "+ $scope.project.City
          $scope.project._urlToShare = configuration.pe4hUrl + seoTitle.toLowerCase().replace(/ /g, "-") +"/rfp/" + $scope.project.UID;

          // Set some calculated values
          $scope.project.closingDate = moment($scope.project.ClosingDate);
          $scope.project.expired = $scope.project.closingDate <= moment();

          $scope.addressString = $scope.project.Address? $scope.project.Address + ', ' : '';

          $scope.project.getRemainingTime = function() {
            var now = moment();

            var diffTime = $scope.project.closingDate.diff(now);
            var duration = moment.duration(diffTime);
            var months = duration.months(),
              days = duration.days(),
              hrs = duration.hours(),
              mins = duration.minutes();
            return {
              months: months,
              days: days,
              hrs: hrs,
              mins: mins
            };
          };

          $scope.project.remainingTime = $scope.project.getRemainingTime();
          $scope.project.status = $scope.project.ProposalsCount >= $scope.maxProposals &&
                                  ! $scope.project.IsPublic &&
                                  $scope.project.Status == "open"
                                  ? { label: "Full", color: "#FF0000" }
                                  : $scope.projectStatesDict[$scope.project.Status];
          $scope.project.license = $scope.licensesDict[$scope.project.LicenseId];

          var clockInterval = $interval(function() {
            $scope.project.remainingTime = $scope.project.getRemainingTime();
          }, 10000);

          // Very important to destroy interval, otherwise we end up stacking intervals
          $scope.$on("$destroy", function() {
            $interval.cancel(clockInterval);
          });

          // load initial public client data
          $http({
            url: configuration.webApi.users.users_id({
              id: $scope.project.UserId
            }),
            method: "GET"
          })
            .success(function(res, status, headers, config) {
              $scope.client = res;

              // load additional data
              // If user is prof, check if he made proposals
              if ($scope.user && $scope.user.IsProfessional) {

                // If the user is professional, update the last_seen date for that project
                $scope.markProjectAsRead();

                $http({
                  url: configuration.webApi.proposals.proposals_project_id_exists(
                    { projectId: $scope.project.Id }
                  ),
                  method: "GET",
                  data: {}
                })
                  .success(function(res, status, headers, config) {
                    $scope.myProposal = res;
                    $scope.project._proposalChecked = true;
                    $scope.getMessages();
                    alreadyPassed();
                  })
                  .error(function(error, status, headers, config) {
                    $scope.alertErrorFromServer(error);
                  });
              } else {
                $scope.project._proposalChecked = true;
              }
            })
            .error(function(error, status, headers, config) {
              $scope.alertErrorFromServer(error);
            });
        })
        .error(function(error, status, headers, config) {
          // TODO: Implement nice looking alerts service/root scope function
          if (status == 404) {
            $scope.alertError("Not Found", "Project Not found.", function() {
              // Go to index if project was not found ?
              $state.go("index");
            });
          } else {
            $scope.alertErrorFromServer(error);
          }
        });
    }

    $scope.alreadyMadeProposal = function() {
      return $scope.myProposal;
    };

    $scope.alreadyHired = function() {
      return $scope.myProposal.Status != configuration.status_to_hide_contact_info_to["engineer"];
    };

    var addUserNameMessages = function() {
      for (i in $scope.messages) {
        if ($scope.messages[i].UserId == $scope.user.Id) {
          $scope.messages[i].name = $scope.user.FullName;
          $scope.messages[i].pictureUrl = $scope.user.Picture
            ? $scope.user.Picture.Url
            : undefined;
        } else {
          $scope.messages[i].name = $scope.client.FullName;
          $scope.messages[i].pictureUrl = $scope.client.Picture
            ? $scope.client.Picture.Url
            : undefined;
        }
      }
    };

    $scope.getMessages = function() {
      if ($scope.alreadyMadeProposal()) {
        $http({
          url: configuration.webApi.proposals.proposals_id_message({
            id: $scope.myProposal.Id
          }),
          method: "GET",
          data: {}
        })
          .success(function(res, status, headers, config) {
            $scope.messages = res;
            addUserNameMessages();
          })
          .error(function(error, status, headers, config) {
            $scope.alertErrorFromServer(error);
          });
      }
    };

    $scope.open = function() {
      $scope.popUp = true;
      $timeout(function() {
        $scope.popUp = false;
      }, 1000);
    };

    function buildLinkedInUrl(url, title, closingDate, license) {
      return (
        "https://www.linkedin.com/shareArticle?mini=true&url=" +
        url +
        "&title=PE4H%20is%20seeking%20a%20" +
        license +
        "&summary=Project%20Title%3A%20" +
        title +
        "%20%7C%20Proposal%20Deadline%3A%20" +
        closingDate +
        "%0A&source="
      );
    }

    function buildFacebookUrl(url) {
      return "https://www.facebook.com/sharer/sharer.php?u=" + url;
    }

    function buildTwitterUrl(url, license) {
      return (
        "https://twitter.com/home?status=PE4H%20is%20seeking%20a%20" +
        license +
        "%20" +
        url
      );
    }

    $scope.shareProject = function() {
      var projectLicense = $scope.licensesDict[$scope.project.LicenseId];
      var seoTitle = "contract " + projectLicense.Label + " job in "+ $scope.project.City
      var url = configuration.pe4hUrl + seoTitle.toLowerCase().replace(/ /g, "-") +"/rfp/" + $scope.project.UID;
      var licenseLabel = $scope.project.license.Label;

      var projectTitle = $scope.project.Title;
      var projectClosingDate = moment($scope.project.ClosingDate).format(
        "MMMM Do YYYY"
      );
      $scope.linkedInUrl = buildLinkedInUrl(
        url,
        projectTitle,
        projectClosingDate,
        licenseLabel
      );
      $scope.facebookUrl = buildFacebookUrl(url);
      $scope.twitterUrl = buildTwitterUrl(url, licenseLabel);

      var modalClose = $uibModal.open({
        templateUrl: "modal-share-project.html",
        size: "md",
        scope: $scope,
        controller: [
          "$scope",
          "$uibModalInstance",
          "$q",
          "$state",
          function($scope, $uibModalInstance, $q, $state) {
            clipboardShare = new Clipboard("#btnClipboardShare");
            $scope.agreed = function() {
              $uibModalInstance.close();
            };
          }
        ]
      });
      modalClose.closed.then(function(data) {
        clipboardShare.destroy();
      });
    };

    $scope.closeProject = function() {
      var modalClose = $uibModal.open({
        templateUrl: "modal-close.html",
        size: "sm",
        scope: $scope,
        controller: [
          "$scope",
          "$uibModalInstance",
          "$q",
          "$state",
          function($scope, $uibModalInstance, $q, $state) {
            $scope.agreed = function() {
              $http({
                url: configuration.webApi.projects.close({
                  id: $scope.project.Id
                }),
                method: "PATCH",
                data: {}
              })
                .success(function(res, status, headers, config) {
                  //console.log(res);
                  $state.reload();
                })
                .error(function(error, status, headers, config) {
                  $scope.alertErrorFromServer(error);
                });
              $uibModalInstance.close();
            };
          }
        ]
      });
      modalClose.closed.then(function(data) {});
    };

    $scope.ignoreProject = function() {
      var modalPass = $uibModal.open({
        templateUrl: "modal-pass.html",
        size: "sm",
        scope: $scope,
        controller: [
          "$scope",
          "$uibModalInstance",
          "$q",
          "$state",
          function($scope, $uibModalInstance, $q, $state) {
            $scope.agreed = function() {
              $http({
                url: configuration.webApi.projects.hide({
                  id: $scope.project.Id
                }),
                method: "PATCH",
                data: {}
              })
                .success(function(res, status, headers, config) {
                  $scope.setHidePass(true);
                })
                .error(function(error, status, headers, config) {
                  $scope.alertErrorFromServer(error);
                });
              $uibModalInstance.close();
            };
          }
        ]
      });
      modalPass.closed.then(function(data) {});
    };

    $scope.signUp = function() {
      LoginService.redirectSignUp($location.url());
    }

    $scope.logIn = function() {
      LoginService.redirectLogIn($location.url());
    }

    var alreadyPassed = function() {
      if (
        $scope.user &&
        $scope.user.IsProfessional &&
        $scope.project.Status == "open" &&
        !$scope.alreadyMadeProposal()
      ) {
        $http({
          url: configuration.webApi.projects.hide({
            id: $scope.project.Id
          }),
          method: "GET",
          data: {}
        })
          .success(function(res, status, headers, config) {
            $scope.setHidePass(res);
          })
          .error(function(error, status, headers, config) {
            $scope.alertErrorFromServer(error);
          });
      }
    };

    // Questions
    $scope.isProjectActive = function () {
        var project = $scope.project || null;
        return !!((project!=null) && (project.Status == 'open') && (project.closingDate > moment()));
    }

    function getProjectQuestions(projectId) {
        $http({url: configuration.webApi.questions.list({projectId: projectId}), method: 'GET'})
        .success(function(res, status, headers, config) {
            $scope.question.list = res;
            // Redirect to #Questions
            $timeout(function(){
              if($location.search() && $location.search().questions){
                $location.hash('Questions');
              }
            }, 200);
          })
          .error(function(error, status, headers, config) {
          });
    }

    $scope.maxQuestionsChar = 2000;

    $scope.updateQuestionCharLeft = function() {
      var textLength = $scope.question.text? $scope.question.text.length: 0;
      $scope.question.remainingCharacters = $scope.maxQuestionsChar - textLength;
    }

    $scope.amIProjectOwner = function () {
      if (!$scope.user || !$scope.project) {
        return false;
      }
      return $scope.user.Id == $scope.project.UserId;
    }

    $scope.confirmSubmitQuestion = function() {
      $uibModal.open({
        templateUrl: "modal-question-confirm.html",
        size: "md",
        scope: $scope,
        controller:['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {

          $scope.data = {
            confirmed: false
          }

          $scope.send = function() {
            $uibModalInstance.close(true)
          }

          $scope.close = function() {
            $uibModalInstance.close(false)
          }
        }],
      }).result.then((function(hasConfirmed) {
        if (hasConfirmed) {
          submitQuestion();
        }
      }))
    }

    function submitQuestion() {
      $http({
        url: configuration.webApi.questions.list({projectId: $scope.project.Id}),
        method: 'POST',
        data: {
          question: $scope.question.text
        }
      }).success(function(res, status, headers, config) {
          getProjectQuestions($scope.project.Id);
          $uibModal.open({
            templateUrl: "modal-question-sent.html",
            size: "sm"
          });
          $scope.question.text = "";
          $scope.form.questionForm.$setPristine();
          $scope.form.questionForm.$setUntouched();
          $scope.updateQuestionCharLeft();
        })
        .error(function(error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    }

    $scope.replyQuestion = function(questionId) {
      var modalPass = $uibModal.open({
        templateUrl: "modal-question-answer.html",
        size: "md",
        scope: $scope,
        backdrop: 'static',
        controller: [
          "$scope", "$uibModalInstance", "Upload",
          function($scope, $uibModalInstance, Upload) {

            function init() {
              var maxFiles = 5
              $scope.files = [];
              $scope.addedFiles = [];

              $scope.maxAnswerLength = 2000;
              $scope.remainingCharacters = $scope.maxAnswerLength;
              $scope.answerText = "";

              $scope.acceptedFileFormats = ".zip,.jpg,.jpeg,.png,.gif,.pdf,.xls,.ppt,.doc,.docx";
              $scope.maxAttachmentFiles = 5;

              $scope.uploadPercentage = 0;
              $scope.isUploading = false;
            }

            $scope.submitAnswer = function() {
              $uibModal.open({
                templateUrl: "modal-answer-confirm.html",
                size: "md",
                scope: $scope,
                controller:['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {

                  $scope.data = {
                    confirmed: false
                  }

                  $scope.send = function() {
                    $uibModalInstance.close(true)
                  }

                  $scope.close = function() {
                    $uibModalInstance.close(false)
                  }
                }],
              }).result.then((function(hasConfirmed) {
                if (hasConfirmed) {
                  $scope.isUploading = true;

                  function onSuccess(res, status, headers, config) {
                    $scope.isUploading = false;
                    $uibModal.open({
                      templateUrl: "modal-answer-sent.html",
                      size: "sm"
                    });
                    getProjectQuestions($scope.project.Id);
                    $uibModalInstance.close();
                  }

                  function onError(error, status, headers, config) {
                    $scope.isUploading = false;
                    $scope.alertErrorFromServer(error);
                  }

                  var upload = Upload.upload({
                    url: configuration.webApi.questions.detail({
                      projectId: $scope.project.Id,
                      questionId: questionId
                    }),
                    data: {
                      answer: $scope.answerText,
                      Attachments: $scope.files
                    }
                  });

                  upload.then(onSuccess, onError)

                  upload.xhr(function(xhr){
                    xhr.upload.addEventListener('progress', function(data) {
                      console.log(data)
                      var percentage = (data.loaded / data.total) * 100;
                      $scope.uploadPercentage = Math.round(percentage);
                    })
                  });
                }
              }))
            };

            $scope.fileCountInvalid = function() {
              return $scope.addedFiles.length > 5;
            }

            $scope.removeFile = function(file) {
              $scope.files = $scope.files.filter(function(obj) { return obj.name != file.name });
            }

            $scope.updateCharactersLeft = function() {
              var answerLength = $scope.answerText ? $scope.answerText.length: 0;
              $scope.remainingCharacters = $scope.maxAnswerLength - answerLength;
            }
            init();
          }
        ]
      });
    }

    $scope.isQuestionFormDisabled = function() {
      return !$scope.user || !$scope.user.IsProfessional || !$scope.isProjectActive();
    }

    function initQuestions() {
        $scope.question = {
          list: [],
          remainingCharacters: $scope.maxQuestionsChar,
          text: ""
        }
    }
    initQuestions();

    $scope.markProjectAsRead = function(){
      $http({
        url: configuration.webApi.questions.markProjectAsRead({
          projectId: $scope.project.Id
        }),
        method: "POST"

      }).success(function(res, status, headers, config) {

        })
        .error(function(error, status, headers, config) {
          console.log("Error updating the read date", error);
        });
    }

    function init() {
      $scope.form={};
      initProject();
      initQuestions();
    };
    init();
  });
